// extracted by mini-css-extract-plugin
export default {"wrapper":"ToggleButton_wrapper__lFWo1","option":"ToggleButton_option__-Z52H","active":"ToggleButton_active__ju3jn"};